import { LengthUnit } from "@/lib/units";
import Input from "./Input";
import { unitOptions } from "./unit";
import SelectUnit from "./SelectUnit";
import useDisplayLengthUnit from "./useDisplayLengthUnit";

export default function Dimensions({
  columns,
  rows,
}: {
  columns: string[];
  rows: { label: string; keyPaths: string[][]; collapse?: boolean }[];
}) {
  const {
    displayLengthUnit: unit,
    setOverrideDisplayUnit,
    toDisplayUnit,
    fromDisplayUnit,
  } = useDisplayLengthUnit({ keyPath: rows[0].keyPaths[0], unit: "length" });

  return (
    <div className="border border-slate-100 py-1 px-1 rounded-sm">
      <table className="text-xs text-gray-400">
        <thead>
          <tr>
            <td scope="col"></td>
            {columns.map((c, i) => (
              <td key={i} scope="col">
                {c}
              </td>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map(({ keyPaths, collapse, label }, i) => (
            <tr key={i} className={`${collapse && "collapse"}`}>
              <td scope="row" className="text-right pr-2 pt-1">
                {label}
              </td>
              {keyPaths.map((keyPath, j) => (
                <td key={j} className="pr-2 pt-1">
                  <Input
                    keyPath={keyPath}
                    unit="length"
                    hideUnit
                    width={40}
                    transformFns={
                      toDisplayUnit && fromDisplayUnit
                        ? {
                            initialValue: toDisplayUnit,
                            saveValue: fromDisplayUnit,
                          }
                        : undefined
                    }
                  />
                </td>
              ))}
              {i === 0 && unit && (
                <td className="text-black text-sm">
                  <SelectUnit
                    value={unit}
                    options={unitOptions.length}
                    onSelect={(toUnit) => {
                      // mutate display unit for this user / "session"
                      // is intentionally lost on page reload
                      setOverrideDisplayUnit(toUnit as LengthUnit);
                    }}
                    width={25}
                  />
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
